export default {
      id: "ic-nav-arrow-top-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-arrow-top-usage",
      toString: function () {
        return this.url;
      }
    }